import { RouterProvider, createBrowserRouter, useRouteError, Outlet, RouteObject } from 'react-router-dom';
import { initReactI18next, useTranslation } from 'react-i18next';
import { SiteContainer } from './components';
import { NotFound, PaymentList, PaymentView, ServiceLogView, WebhookView, PayoutView, PayoutList, WebhookList, WebhookResponse } from './screens'
import { BreadcrumbsProvider, UserProvider } from './Hooks';
import { SiteRoute } from './DashboardClasses';
import { joinUrls } from '@payfront/components/Util';
import ReactDOM from 'react-dom/client';
import resourcesToBackend from "i18next-resources-to-backend";
import i18n from 'i18next';
import 'frontier-css/css/frontier.css';
import UserList from './screens/UserList';
import UserView from './screens/UserView';

i18n.use(initReactI18next).use(resourcesToBackend(async (l: string)=>{
	var lang = (await import(`./locale/dashboard.${l}.json`)).default;
	return lang;
})).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var ErrorElement = ()=>{
	var { t } = useTranslation();
	const error = (useRouteError() as any);
	return <NotFound
		code={'404'} 
		text={error.status===404 ? t('common.page_notfound') : t('common.unexpected_error', { code: `ERRELM-${error.status}` })}
	/>
}

const site_routes : SiteRoute[] = [{
	path: '/pagos',
	element: <PaymentList />,
	title: 'Pagos',
	iconName: 'money-bill-wave',
	children: [{
		path: '/:payment_id',
		element: <PaymentView />,
		title: (params: { payment_id: number })=>{
			return `Pago: ${params.payment_id}`;
		},
		children: [{
			path: '/webhook/:response_id',
			element: <WebhookResponse />,
			title: (params: { response_id: number })=>{
				return `Webhook: ${params.response_id}`;
			}
		}, {
			path: '/service/:log_id',
			element: <ServiceLogView />,
			title: (params: { log_id: number })=>{
				return `Log: ${params.log_id}`;
			}
		}]
	}],
}, {
	path: '/payouts',
	element: <PayoutList />,
	title: 'Liquidaciones',
	iconName: 'money-check-alt',
	children: [{
		path: '/:id',
		element: <PayoutView />,
		title: p=>`Liquidación: ${p.id}`,
	}]
}, {
	path: '/webhooks',
	element: <WebhookList />,
	title: 'Webhooks',
	iconName: 'share-alt',
	children: [{
		path: '/:webhook_id',
		element: <WebhookView />,
		title: p=>`Webhook: ${p.webhook_id}`,
		children: [{
			path: '/response/:response_id',
			element: <WebhookResponse />,
			title: p=>`Respuesta: ${p.response_id}`
		}]
	}]
}, {
	path: '/users',
	element: <UserList />,
	title: 'Usuarios',
	iconName: 'users',
	children: [{
		path: '/:user_id',
		element: <UserView />,
		title: p=>`Usuario: ${p.user_id}`
	}]
}]

var getBrowserRoute = (parent: string, route: SiteRoute) : RouteObject[]=>{
	var r : RouteObject[] = [];
	var path = joinUrls(parent, route.path);
	r.push({
		path: path,
		element: route.element,
	})
	if(route.children){
		for(var c of route.children){
			r.push(...getBrowserRoute(path, c))
		}
	}
	return r;
}

var browser_routes : RouteObject[] = [];
for(var i of site_routes){
	browser_routes.push(...getBrowserRoute('/', i));
}

var SiteContainerContainer = (props: any)=>{
	return <BreadcrumbsProvider routes={site_routes}>
		<SiteContainer {...props} />
	</BreadcrumbsProvider>
}

const Router = createBrowserRouter([{
	path: '/',
	errorElement: <SiteContainerContainer outlet={<ErrorElement />} />,
	element: <SiteContainerContainer outlet={<Outlet />} />,
	children: [
		{ path: '/', element: <PaymentList /> },
		...browser_routes
	]
}]);

var Root = ()=>{
	return <UserProvider>
		<RouterProvider router={Router} />
	</UserProvider>
}

root.render(<Root />);